<template>
  <div>
    <van-button round size="small" type="info" @click="newRequire">发布新需求</van-button>
    <van-swipe-cell v-for="(item,index) in requireList" :key="index" >
      <van-card
        :title=item.title
        :desc=item.tips
        >
<!--      <template #footer>-->
<!--        <div>{{ item.status == 0 ? "未回复" : "已回复" }}</div>-->
<!--      </template>-->
    </van-card>
    </van-swipe-cell>
  </div>
</template>
<script>
import URL from "@/api/api";
export default {
  data(){
    return{
      requireList: [],
      openid:localStorage.getItem("openid")
    }
  },
  mounted() {
    this.getRequireList();
  },
  methods:{
    getRequireList(){
      this.$fetchGet(URL.getTips.url, {openid: this.openid}).then((res) => {
        this.requireList = res.data.data
      });
    },
    newRequire(){
      this.$router.push('/releaseNeed/details')
    }
  }
}
</script>
<style scoped>
.van-button--round{
  width: 65px;
  margin-left: 10px;
  border-radius: 10px;
}
.van-card {
  margin: 10px;
}
.van-card__footer {
  position: absolute;
  z-index: 99;
  top: 10px;
  right: 10px;
  color: red;
}
</style>
